<mat-form-field class="w-100-p" appearance="outline">
    <mat-label>{{ 'GEOGRAPHY.PROVINCE' | translate }}</mat-label>
    <input
        [formControl]="provinceController"
        type="text"
        [placeholder]="'GEOGRAPHY.PROVINCE' | translate"
        matInput
        #provinceSearch
        (keyup)="filterProvinces(provinceSearch.value)"
        [matAutocomplete]="auto"
    />
    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="getProvince($event)"
    >
        <mat-option *ngFor="let p of filteredProvinces" [value]="p">
            {{ p.name }}
        </mat-option>
    </mat-autocomplete>

    <mat-error>{{ 'GEOGRAPHY.INPUT_PROVINCE' | translate }}</mat-error>
</mat-form-field>

<mat-form-field class="w-100-p" appearance="outline">
    <mat-label>{{ 'GEOGRAPHY.VILLAGE' | translate }}</mat-label>
    <input
        [formControl]="townController"
        type="text"
        [placeholder]="'GEOGRAPHY.VILLAGE' | translate"
        matInput
        #townSearch
        (keyup)="filterTowns(townSearch.value)"
        [matAutocomplete]="autoCompleteTown"
    />
    <mat-autocomplete
        #autoCompleteTown="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="getTown($event)"
    >
        <mat-option *ngFor="let town of filteredTowns" [value]="town">
            {{ town.name }}
        </mat-option>
    </mat-autocomplete>
    <mat-error>{{ 'GEOGRAPHY.INPUT_VILLAGE' | translate }}</mat-error>
</mat-form-field>

<mat-form-field
    *ngIf="industrialParks.length"
    class="w-100-p"
    appearance="outline"
>
    <mat-label>{{ 'GEOGRAPHY.INDUSTRIAL_PARK' | translate }}</mat-label>
    <input
        [formControl]="industryParkController"
        type="text"
        [placeholder]="'GEOGRAPHY.INDUSTRIAL_PARK' | translate"
        matInput
        #industryParkSearch
        (keyup)="filterIndustrialParks(industryParkSearch.value)"
        [matAutocomplete]="autoCompleteIndustrialPark"
    />
    <mat-autocomplete
        #autoCompleteIndustrialPark="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="getIndustrialPark($event)"
    >
        <mat-option
            *ngFor="let industrialPark of filteredIndustrialParks"
            [value]="industrialPark"
        >
            {{ industrialPark.name }}
        </mat-option>
    </mat-autocomplete>
    <mat-error>{{ 'GEOGRAPHY.INPUT_INDUSTRIAL_PARK' | translate }}</mat-error>
</mat-form-field>
